export interface ClanProfile {
  clanId: string;
  clanName: string;
  clanStatsTurnover: string;
  isVisible: boolean;
  presentation: ClanPresentation;
}

export interface ClanMember {
  id: string;
  clanId: string;
  clanName: string;
  workerId: string;
  workerUsername: string;
  contact?: string;
  status: ClanMemberStatus;
  role: ClanRole;
  lastLeadAt: Date | null;
  turnover: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface Clan {
  id: string;
  name: string;
  leaders: ClanLeaders;
  contact: ClanContact;
  stats: ClanStats;
  recruitment: ClanRecruitment;
}

export interface ClanApplication {
  id: string;
  clanId: string;
  clanName: string;
  workerId: string;
  workerUsername: string;
  status: ClanApplicationStatus;
  text: string;
  contact: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface ClanInviteLink {
  id: string;
  name: string;
  usedCount: number;
  lastUseAt: Date | null;
  joinedCount: number;
  lastJoinAt: Date | null;
  createdAt: Date;
}

export type ClanRecruitment = {
  status: ClanRecruitmentStatus;
};

export type ClanStats = {
  leadsCount: number;
  membersCount: number;
  turnover: string;
};

export type ClanContact = {
  main: string;
  reserve: string;
};

export type ClanLeaders = {
  first: ClanLeader;
  second?: ClanLeader;
};

export type ClanLeader = {
  workerId: string;
  workerUsername: string;
};

export type ClanPresentation = {
  imageURL: string;
  description: string;
};

export enum ClanRole {
  LEADER = "leader",
  MEMBER = "member",
}

export enum ClanMemberStatus {
  ACTIVE = "active",
  KICKED = "kicked",
}

export enum ClanRecruitmentStatus {
  OPEN = "open",
  CLOSED = "closed",
}

export enum ClanApplicationStatus {
  OUTDATED = "outdated",
  APPROVED = "approved",
  REJECTED = "rejected",
  PENDING = "pending",
}
